import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { getEvent } from "../../../Redux/eventsReducer"
import AdminLayout from "../../UI/Admin/AdminLayout/AdminLayout"
import PageHeader from "../../UI/Admin/PageHeader/PageHeader"
import { useParams } from 'react-router-dom';
import Preloader from "../../Common/Preloader/Preloader"
import AdminEvent from "./AdminEvent"
import { getTickets } from "../../../Redux/ticketsReducer"
import _ from 'lodash';

const AdminEventContainer = (props) => {
    const { event, getEvent, isFetching, getTickets, tickets } = props

    const { code } = useParams();

    const [sortedTickets, setSortedTickets] = useState([])

    useEffect(() => {
        if (code) {
            getEvent(code)
        }
    }, [code])

    useEffect(() => {
        if (event) {
            getTickets(1, 100000, "", "", event.title, false)
        }
    }, [event])

    useEffect(() => {
        if (event && tickets.length > 0) {
            const grouped = _(tickets)
                .filter(t => t.event._id.toString() === event._id) // фильтрация по ивенту
                .groupBy(t => t.ticketType.name)
                .map((items, name) => ({
                type: name,
                sold: items.length
                }))
                .orderBy(['sold'], ['desc']) // сортировка по количеству
                .value();

            setSortedTickets(grouped)
        }
    }, [tickets, event])

    return (
        <AdminLayout>
            {isFetching && <Preloader/>}
            {event ? (
                <>
                    <PageHeader
                        title={event.title}
                        searchBar={false}
                        createBut={false}
                        currentEvent={null}
                        isHaveBackButton={true}
                    />
                    <AdminEvent event={event} tickets={sortedTickets}/>
                </>
            ) : <></>}
        </AdminLayout>
    )
}

let mapStateToProps = (state) => ({
    event: state.events.event,
    tickets: state.tickets.tickets,
    isFetching: state.common.isFetching,
})

export default connect(mapStateToProps, {
    getEvent, getTickets
})(AdminEventContainer)